import { defineStore } from 'pinia';

import { User } from '@/models/assignato/user';

export const useAuthenticationStore = defineStore('authentication', {
    state: () => ({
        user: null as User | null,
        isAuthenticated: false
    }),
    actions: {
        setUser(user: User) {
            if (user && user.id) {
                this.user = user;
                this.isAuthenticated = true;
            }
        },
        removeUser() {
            this.user = null;
            this.isAuthenticated = false;
        }
    }
});